export const keycloakApiRoutes = {
    KEYCLOAK_USER_PATH: '/ms/company/api/v1/user/',
    GROYP_PATH: '/group/',
    SUBGROYP_PATH: '/subgroup/',
}
